import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useBrand } from './BrandContext';

const themes = {
    bz: {
      '--color-primary': '#e88421',
      '--color-primary-light': '#f0952e',
      '--color-primary-dark': '#d97510',
      '--color-primary-subtle': '#fff7ed'
    },
    qikerp: {
      '--color-primary': '#0b5d1e',
      '--color-primary-light': '#0d6e23',
      '--color-primary-dark': '#094d19',
      '--color-primary-subtle': '#0b5d1e14',
    },
  };

  
  const BrandSync = () => {
    const [searchParams] = useSearchParams();
    const { updateBrand, brand } = useBrand();

    useEffect(() => {
        const m = searchParams.get('m');
        if (m) updateBrand(m);
    }, [searchParams]);

    useEffect(() => {
        const theme = themes[brand] || themes.bz;
        const root = document.documentElement;
        Object.entries(theme).forEach(([key, value]) => {
            root.style.setProperty(key, value);
        });
    }, [brand]);

    return null;
};

export default BrandSync;